
import { FrontendStoreLocator, StoreState } from "@/interfaces";
import { computed, defineComponent, ref, watch } from "vue";
import { GoogleMap, Marker } from "vue3-google-map";
import { useStore } from "vuex";

export default defineComponent({
  name: "StoreLocatorMap",
  components: {
    GoogleMap,
    Marker,
  },
  setup() {
    const store = useStore<StoreState>();
    const mapRef = ref(null);

    const mapCenter = computed(() => {
      if (store.state.selectedStoreLocator == null || store.state.countStoreLocators === 0) {
        return { lat: 43.9559491, lng: 12.4265958 };
      }

      return {
        lat: +store.state.selectedStoreLocator.latitude,
        lng: +store.state.selectedStoreLocator.longitude,
      };
    });

    const storeLocatorMarkers = computed(() => {
      const out: FrontendStoreLocator[] = [];
      for (const sl of store.state.storeLocators) {
        out.push(...sl)
      }

      return out;
    });

    watch(storeLocatorMarkers, (currentValue) => {
      const map = mapRef.value as any;
      if (!map.ready || storeLocatorMarkers.value.length === 0) return;
      let bounds = new map.api.LatLngBounds();
      for (const b of storeLocatorMarkers.value) {
        bounds.extend({ lat: +b.latitude, lng: +b.longitude });
      }

      map.map.fitBounds(bounds);
    });

    const getMarker = (el: FrontendStoreLocator) => {
      // Ref to https://developers.google.com/maps/documentation/javascript/reference/marker
      return {
        title: el.name + el.lastname,
        clickable: true,
        position: {
          lat: +el.latitude,
          lng: +el.longitude,
        },
        icon:
          store.state.selectedStoreLocator != null &&
          store.state.selectedStoreLocator.id === el.id
            ? require("@/assets/img/map-marker-active.png")
            : el.franchising === true
            ? require("@/assets/img/map-marker-franchising.png")
            : require("@/assets/img/map-marker.png"),
      };
    };

    const onClickMarker = (el: FrontendStoreLocator) => {
      store.commit("setStoreLocator", {
        storeLocator: el,
        move: true,
      });
    };

    return {
      mapCenter,
      storeLocatorMarkers,
      getMarker,
      onClickMarker,
      mapRef,
    };
  },
});
